const mutations = {
  setTradePlanList(state, payload) {
    state.tradePlanList = payload;
  },
  setTradePlan(state, payload) {
    state.tradePlan.tradePlanNo = payload.tradePlanNo;
    state.tradePlan.headerForm = payload.headerForm;
  },
  setTradePlanDetail(state, payload) {
    state.tradePlanDetail = payload;
  },
  setBudgetHeadGridData(state, payload) {
    Object.keys(payload).forEach((key) => {
      state.budgetHeadGridData[key] = payload[key];
    });
  },
  setBudgetHeadList(state, payload) {
    state.budgetHeadList = payload;
  },
  setSalesDetails(state, payload) {
    state.salesDetails = payload;
  },
  setSalesDeductionPlanList(state, payload) {
    state.salesDeductionPlan = payload;
  },
  setPlanDetailList(state, payload) {
    state.planDetailList = payload;
  },
  setNetSalesList(state, payload) {
    state.netSalesList = payload;
  },
  setStoreBudgetHeadObject(state, payload) {
    state.budgetHeadObject = payload;
  },

};

export default mutations;
